"use client";

import type { ReactNode } from "react";

import { useRomaReserveSheet } from "@/components/roma/roma-reserve-sheet-context";

type RomaReserveSheetButtonProps = {
  className?: string;
  children: ReactNode;
  /** External reservation URL used when the native sheet is unavailable. */
  fallbackHref?: string;
  trackLocation?: string;
  trackLabel?: string;
};

/**
 * Single Reserve control for the Roma dark funnel. When the native location
 * picker sheet is available it opens that (the SH-vs-Henderson choice happens
 * after commitment); otherwise it falls back to an external reservation link.
 */
export function RomaReserveSheetButton({
  className,
  children,
  fallbackHref,
  trackLocation,
  trackLabel,
}: RomaReserveSheetButtonProps) {
  const sheet = useRomaReserveSheet();

  if (sheet?.enabled) {
    return (
      <button
        type="button"
        onClick={() => sheet.openSheet()}
        data-track="reservation_clicked"
        data-track-location={trackLocation}
        data-track-label={trackLabel}
        className={className}
      >
        {children}
      </button>
    );
  }

  if (!fallbackHref) return null;

  return (
    <a
      href={fallbackHref}
      target="_blank"
      rel="noopener noreferrer"
      data-track="reservation_clicked"
      data-track-location={trackLocation}
      data-track-label={trackLabel}
      className={className}
    >
      {children}
    </a>
  );
}

export default RomaReserveSheetButton;
